import { Component, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ThemeOption, ThemeService } from 'src/app/services/theme.service';
import { ViewService } from 'src/app/services/view.service';
import { Router, NavigationEnd } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { ToastService } from 'src/app/services/toast.service';
import { InvoicesService } from 'src/app/services/invoices.service';

@Component({
  selector: 'app-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrl: './mobile-nav.component.scss',
})
export class MobileNavComponent {
  @ViewChild('mobileNavMenu', { static: true })
  mobileNav!: ElementRef<HTMLDetailsElement>;

  mobileNavOpen: boolean = false;

  currentMobileBottomNavTab = '';

  constructor(
    private authService: AuthService,
    private invoicesService: InvoicesService,
    private themeService: ThemeService,
    private router: Router,
    private firebaseService: FirebaseService,
    public viewService: ViewService,
    private toastService: ToastService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('this.router.url: ', this.router.url);
        this.currentMobileBottomNavTab = this.router.url;
      }
    });
  }

  get showAdmin() {
    return this.authService.isAdmin();
  }

  signOut() {
    this.authService.signOut().subscribe();
  }

  get currentTenant() {
    return this.authService.currentTenantInfo?.tenant;
  }

  get darkModeEnabled() {
    return this.themeService.theme === 'accuzipDarkTheme';
  }

  get userImageURL() {
    if (!this.firebaseService.currentUser) {
      return;
    }

    return this.firebaseService.currentUser.photoURL;
  }

  get cartItemCount() {
    if (!this.invoicesService.pendingInvoice) {
      return 0;
    }

    return this.invoicesService.pendingInvoice.license_details.length;
  }

  copyAccountNumber() {
    if (this.currentTenant) {
      navigator.clipboard.writeText(this.currentTenant.account_number);
      this.toastService.addToast('info', 'Account number copied to clipboard');
    }
  }

  updateTheme(ev: Event) {
    const theme = (ev.target as HTMLSelectElement).value as ThemeOption;
    this.themeService.setTheme(theme, true);
  }

  handleThemeChange(ev: Event) {
    if (ev.target) {
      if ((ev.target as HTMLInputElement).checked) {
        this.themeService.setTheme('accuzipDarkTheme', true);
      } else {
        this.themeService.setTheme('accuzipLightTheme', true);
      }
    }
  }

  toggleMobileNav(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();

    this.mobileNavOpen = !this.mobileNavOpen;

    if (this.mobileNavOpen) {
      this.mobileNav.nativeElement.setAttribute('open', '');
    } else {
      this.mobileNav.nativeElement.removeAttribute('open');
    }
  }
}
